'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FireIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.9466 20.7152C14.4889 20.2461 14.1342 19.8228 13.8139 19.2164C13.219 18.0838 12.9673 16.7795 12.7842 15.5897C11.0795 17.0198 9.72949 18.6444 9.46635 20.761M19.4772 13.9078C19.4772 14.9604 19.2598 15.9443 18.8594 16.8482C17.7267 19.4224 15.1525 21.23 12.155 21.23C8.10487 21.23 4.83276 17.9351 4.83276 13.9078C4.83276 11.837 5.69083 9.96072 7.07519 8.64501C7.7502 9.80054 8.71124 10.7616 9.88966 11.4023C9.76381 10.876 9.69516 10.3268 9.69516 9.77766C9.69516 8.72509 9.91254 7.74117 10.313 6.83734C11.1825 4.83517 12.9215 3.31353 15.061 2.73004C15.0266 2.94742 15.0152 3.17624 15.0152 3.40506C15.0152 5.41866 15.8389 7.26065 17.1547 8.5878C17.2119 8.64501 17.2576 8.69077 17.3263 8.74798C17.7839 9.20561 18.1615 9.70902 18.4818 10.2582C19.1111 11.3336 19.4657 12.5921 19.4657 13.9307L19.4772 13.9078Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpFireIcon = forwardRef(FireIcon);

export { VpFireIcon as default };
